import React from 'react';
import PropTypes from 'prop-types';
import { withStyles } from '@material-ui/styles';
import Drawer from '@material-ui/core/Drawer';
import StaffBurgerList from '../staff-burger-list/StaffBurgerList';

const StyledDrawer = withStyles({
    paperAnchorLeft: {
        width: '410px',
        paddingTop: '50px',
        borderRadius: '0px 7px 7px 0px',
    },
})(Drawer);

const Menu = ({ staff, institution, isBurgerMenuVisible, onBurgerMenuClose }) => (
    <StyledDrawer open={isBurgerMenuVisible} onClose={onBurgerMenuClose}>
        <StaffBurgerList staff={staff} institution={institution} />
    </StyledDrawer>
);

Menu.defaultProps = {
    isBurgerMenuVisible: false,
    onBurgerMenuClose: () => {},
    staff: null,
    institution: null,
};

Menu.propTypes = {
    isBurgerMenuVisible: PropTypes.bool,
    onBurgerMenuClose: PropTypes.func,
    staff: PropTypes.object,
    institution: PropTypes.object,
};

export default Menu;
